interface ScoreAverages {
  lcp: number | null;
  inp: number | null;
  cls: number | null;
}

type BudgetAverages = Record<string, number | null>;
type BudgetThresholds = Record<string, number>;

export const DEFAULT_PERFORMANCE_BUDGET: BudgetThresholds = {
  LCP: 2500,
  INP: 200,
  CLS: 0.1,
  FCP: 1800,
  TTFB: 600,
};

export const calculatePerformanceScoreFromAverages = (
  averages: ScoreAverages,
): number => {
  let score = 100;

  if (averages.lcp) {
    if (averages.lcp > 4000) score -= 30;
    else if (averages.lcp > 2500) score -= 15;
  }

  if (averages.inp) {
    if (averages.inp > 500) score -= 25;
    else if (averages.inp > 200) score -= 10;
  }

  if (averages.cls) {
    if (averages.cls > 0.25) score -= 25;
    else if (averages.cls > 0.1) score -= 10;
  }

  return Math.max(0, score);
};

export const buildPerformanceBudgetViolations = (
  thresholds: BudgetThresholds,
  averages: BudgetAverages,
): string[] => {
  const violations: string[] = [];

  Object.entries(thresholds).forEach(([metric, threshold]) => {
    const average = averages[metric];
    if (average && average > threshold) {
      violations.push(
        `${metric}: ${average.toFixed(2)} (budget: ${threshold})`,
      );
    }
  });

  return violations;
};
